// extracted by mini-css-extract-plugin
module.exports = {"myVideo":"videos_myVideo__1QGIK","video":"videos_video__1DbHt","otherVideos":"videos_otherVideos__2kWuv"};